const updates = [
  { date: '08-01', title: '《暗夜追踪》高清版正式上线极速影视', tag: '新片上线' },
  { date: '07-31', title: '《春风十里不如你》大结局全网首播', tag: '热播追剧' },
  { date: '07-30', title: '暑期档特别专题"高分经典回顾"已更新', tag: '专题更新' },
  { date: '07-29', title: '极速影视综艺频道新增3档热门脱口秀', tag: '内容上新' },
  { date: '07-28', title: '平台播放技术升级，高清流畅度提升30%', tag: '平台动态' },
  { date: '07-27', title: '《深海密码》导演独家专访内容上线', tag: '独家内容' },
  { date: '07-26', title: '本周新上线电影共12部，电视剧更新86集', tag: '更新汇总' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
            最新快讯
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto leading-relaxed">
            影视动态与平台更新一手掌握
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          {updates.map((item, i) => (
            <div key={i} className="relative flex gap-5 pb-8 last:pb-0">
              {i < updates.length - 1 && (
                <div className="absolute left-[19px] top-10 bottom-0 w-px bg-background-300"></div>
              )}
              <div className="relative flex-shrink-0 w-[39px] h-[39px] rounded-full bg-primary-100 flex items-center justify-center z-10">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-500"></div>
              </div>
              <div className="flex-1 pt-0.5">
                <div className="flex items-center gap-3 flex-wrap mb-1.5">
                  <span className="text-xs text-foreground-500 font-medium whitespace-nowrap">{item.date}</span>
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-md whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 leading-relaxed">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}